<template>
 <div class="panel panel-grid-item" :class="{'bg-slate-300': editable , 'bg-white': !editable}">
    <!-- Iconos acciones -->
    <div :class="{ 'vue-draggable-handle glyphicon glyphicon-move': editable }"></div>
    <div
      :class="{ 'vue-removable-handle glyphicon glyphicon-remove': editable }"
      @click="onClickEliminar()"
    ></div>
    <div
      :class="{ 'vue-collapsable-handle glyphicon glyphicon-chevron-up': !collapsed && !editable }"
      style="color: #4d4d4d !important;"
      @click="cambiarCollapsed(true)"
    ></div>
    <div
      :class="{ 'vue-collapsable-handle glyphicon glyphicon-chevron-down': collapsed && !editable }"
      style="color: #4d4d4d !important;"
      @click="cambiarCollapsed(false)"
    ></div>
    <!-- //Iconos acciones -->
    <!-- Modo editando -->
    <div class="pt-2 bg-slate-300" style="height: 100%;" v-if="editable && !collapsed">
      <span :class="{ 'titulo-colapsado' : !editable, 'titulo-colapsado-editando' : editable }">Analisis Sección</span>
    </div>
    <!-- Modo editando -->
    
    <div class="pt-2" v-if="!editable && !collapsed">
      <span class="titulo-colapsado">Analisis Sección</span>
    </div>
    <!-- Modo colapsado -->
    <div
      v-else
      class="pt-2"
      :class="{'pointer' : !editable}"
      @click="!editable ? cambiarCollapsed(false) : null"
    >
      <span
        :class="{ 'titulo-colapsado' : !editable, 'titulo-colapsado-editando' : editable }"
      >Analisis Sección</span>
    </div>
    <!-- //Modo colapsado -->
   <div v-if="!editable && !collapsed" class="mt-2">
      <b-row>
        <b-col  cols="12" sm="12">
          <v-select
            v-model="vcomboTiempo"
            :items="comboTiempo"
            item-value="id"
            item-text="name"
            value="Hoy"
            hide-details
            solo
            attach
            @change="actualizarTabla()"
          ></v-select>
        </b-col>
        <b-col  cols="12" sm="12" class="columna-content mt-2">
          <div>
            <v-data-table
              :headers="headers"
              :items="datosTabla"
              :sort-by="['id.ps0004_seccion']"
              item-key="id.ps0004_seccion"
              hide-actions
              :items-per-page= "100000"
              :mobile-breakpoint = "365"
              :loading = cargando
              class="elevation-5"
              style="overflow: auto; width: 100%;"
              :footer-props="{itemsPerPageText: 'Rows count'}"
            >
            <template v-slot:items="props">
              <tr>
                <td class="text-center">{{ props.item.id.ps0004_seccion }}</td>
                <td class="text-xs-right">{{ props.item.ps0004_Unidades }}</td>
                <td class="text-xs-right">{{ formatNum(props.item.ps0004_Valor) }}€</td>
                <td class="text-xs-right">{{ formatNum(props.item.ps0004_Beneficio) }}€</td>
                <td class="text-center">{{ props.item.ps0004_ROI }}</td>
              </tr>
            </template>
            <template v-slot:footer>
              <tr class="totales">
                  <td class="text-center">TOTAL</td>
                  <td class="text-right">{{totalUnidades}}</td>
                  <td class="text-right">{{totalValor}}€</td>
                  <td class="text-right">{{totalBeneficio}}€</td>
                  <td class="text-center">{{totalRoi}}</td>
              </tr>
            </template>
            <template v-slot:no-data>
              <v-alert :value="true">
                No hay datos
              </v-alert>
            </template>
           </v-data-table>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { PsApiService } from '@/api/PsApiService'
import { Util } from '@/api/Util'

const psApiService = new PsApiService()
const util = new Util()

export default {
  props: {
    data: Object,
    config: Object,
    editable: Boolean,
    collapsed: Boolean,
    altura: Number,
    id: Number,
    refrescar: Number
  },
  data () {
    return {
      vcomboTiempo: 1,
      comboTiempo: [
        {
          id: 1,
          name: 'Ayer'
        },
        {
          id: 2,
          name: 'Hoy'
        },
        {
          id: 3,
          name: 'Semana'
        },
        {
          id: 4,
          name: 'Mes'
        },
        {
          id: 5,
          name: 'Año'
        }
      ],
      datosTabla: [],
      headers: [
        {
          text: 'Seccion',
          align: 'center',
          sortable: true,
          value: 'id.ps0004_seccion',
          width: '20%'
        },
        { text: 'Unidades', sortable: true, value: 'ps0004_Unidades', align: 'right', width: '20%' },
        { text: 'Valor', sortable: true, value: 'ps0004_Valor', align: 'right', width: '20%' },
        { text: 'Beneficio', sortable: true, value: 'ps0004_Beneficio', align: 'right', width: '20%' },
        { text: '% ROI', sortable: false, value: 'ps0004_ROI', align: 'center', width: '20%' }
      ]
    }
  },
  computed: {
    regenerar () {
      return this.$store.getters.isRegenerarTablas
    },
    totalUnidades () {
      if (this.datosTabla.length) {
        let sum
        sum = this.datosTabla.map(item => item.ps0004_Unidades).reduce((prev, next) => prev + next)
        return sum
      } else {
        return 0
      }
    },
    totalValor () {
      if (this.datosTabla.length) {
        let sum
        sum = this.datosTabla.map(item => item.ps0004_Valor).reduce((prev, next) => prev + next)
        sum = sum.toLocaleString(undefined, { minimumFractionDigits: 0 })
        return sum
      } else {
        return 0
      }
    },
    totalBeneficio () {
      if (this.datosTabla.length) {
        let sum
        sum = this.datosTabla.map(item => item.ps0004_Beneficio).reduce((prev, next) => prev + next)
        sum = sum.toLocaleString(undefined, { minimumFractionDigits: 0 })
        return sum
      } else {
        return 0
      }
    },
    totalRoi () {
      if (this.datosTabla.length) {
        let sum, sum2, porcentaje
        sum = this.datosTabla.map(item => item.ps0004_ValorVentaSinIVA).reduce((prev, next) => prev + next)
        sum2 = this.datosTabla.map(item => item.ps0004_Costo).reduce((prev, next) => prev + next)
        porcentaje = Math.round(((sum - sum2) / sum) * 100)
        // porcentaje = ((sum2 / sum) * 100).toFixed(2)
        return porcentaje
      } else {
        return 0
      }
    }
  },
  watch: {
    regenerar (value) {
      console.log(`My store value for 'regenerar' changed to ${value}`)
      this.actualizarTabla()
    },
    refrescar (value) {
      this.actualizarTabla()
    }
  },
  methods: {
    formatNum (numero) {
      if (numero !== undefined) {
        return numero.toLocaleString(undefined, { minimumFractionDigits: 0 })
      } else {
        return null
      }
    },
    onClickEliminar() {
      if (this.id != undefined) {
        this.$emit("eliminaranalisisseccion", this.id);
      }
    },
    cambiarCollapsed(value) {
      let collapseOptions = {};
      collapseOptions.collapse = value;
      collapseOptions.id = this.id;
      collapseOptions.tipo = this.config.tipo;
      collapseOptions.altura = this.altura;
      this.$emit("collapse", collapseOptions);
    },
    actualizarTabla () {
      this.cargando = true
      psApiService
        .getAnalisisSeccion(this.vcomboTiempo)
        .then(data => {
          this.datosTabla = data
          util.mostrarEnConsola(
            'getAnalisisSeccion',
            data.length,
            'OK'
          )
          this.cargando = false
        })
        .catch(error => {
          util.mostrarEnConsola(
            'getAnalisisSeccion',
            error,
            'ERROR'
          )
          this.datosTabla = []
          this.cargando = false
        })
    }
  },
  created () {
    this.actualizarTabla()
  }
}
</script>
